/** @jsxImportSource @emotion/react */

import React from 'react';
import locationItemSkeletonStyles from './location-item-skeleton.styles';
import { Skeleton } from '@mui/material';

const GENTLE_GRAY = '#D1D5DB';
const sxProps = { background: GENTLE_GRAY };
const SKELETON_ITEMS_COUNT = 4;
const skeletonItems: number[] = new Array(SKELETON_ITEMS_COUNT).fill(0).map((_, i) => i);

export const LocationItemsSkeleton = () => {
    return (
        <>
            {skeletonItems.map(key => (
                <div css={locationItemSkeletonStyles.container} key={key}>
                    <div css={locationItemSkeletonStyles.leftSkeletonsContainer}>
                        <div css={locationItemSkeletonStyles.topSkeletons}>
                            <Skeleton sx={sxProps} variant="rounded" width={52} height={20} />
                            <Skeleton sx={sxProps} variant="rounded" width={52} height={20} />
                        </div>

                        <div css={locationItemSkeletonStyles.bottomSkeletons}>
                            <Skeleton sx={sxProps} variant="rounded" width={215} height={16} />
                            <Skeleton sx={sxProps} variant="rounded" width={215} height={16} />
                        </div>
                    </div>
                    <Skeleton sx={sxProps} variant="rounded" width={24} height={24} />
                </div>
            ))}
        </>
    );
};
